/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserMiningCommissionItem } from './user-mining-commission-item';


export interface UserMiningCommissionsResponse { 
    userId: string;
    items: Array<UserMiningCommissionItem>;
}

